export interface UserNotificationModel {
  id: string;
  type: UserNotificationType;
  title: string;
  message?: string;
  data?: string; // JSON string
  isRead: boolean;
  createdDate: Date;
  readDate?: Date;
  expiresDate?: Date;
}

export enum UserNotificationType {
  Download = 'Download',
  System = 'System',
  Alert = 'Alert',
  ProjectUpdate = 'ProjectUpdate',
  CommentReply = 'CommentReply',
  FileProcessed = 'FileProcessed',
}

export interface UserNotificationData {
  downloadJobId?: string;
  fileName?: string;
  status?: string;
  errorMessage?: string;
  projectId?: number;
  postId?: number;
  commentId?: number;
  [key: string]: any; // Allow additional properties
}

export interface UnreadCountResponse {
  unreadCount: number;
}
